import RequiredFieldMessage from './RequiredFieldMessage';

export default RequiredFieldMessage;
